
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","viewBox":"0 0 7 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.603 5.844L4.22 3.484 6.58 1.1 5.845.373l-2.36 2.383L1.102.396l-.73.73L2.759 3.49.396 5.874l.73.73L3.49 4.216 5.875 6.58l.728-.736z","fill":"#fff"}})])
          )
        }
      }
    